import { AppImageLoaderConfig } from '@pool-league/frontend-shared-util-app-config';

export const APP_IMAGE_LOADER_CONFIG: AppImageLoaderConfig = {
  placeholders: {
    'hero/hero-andy.avif': 'hero/hero-andy-128.webp',
    'img/cone/cone.png': 'img/cone/cone-24.png',
  },
  sizedImages: {
    'hero/hero-andy.avif': [
      { src: 'hero/hero-andy-640.avif', width: 640 },
      { src: 'hero/hero-andy-750.avif', width: 750 },
      { src: 'hero/hero-andy-828.avif', width: 828 },
      { src: 'hero/hero-andy-1080.avif', width: 1080 },
      { src: 'hero/hero-andy-1200.avif', width: 1200 },
      { src: 'hero/hero-andy-1920.avif', width: 1920 },
      { src: 'hero/hero-andy-2048.avif', width: 2048 },
      { src: 'hero/hero-andy.avif', width: 4080 },
    ],
    'img/cone/cone.png': [
      { src: 'img/cone/cone-24.png', width: 24 },
      { src: 'img/cone/cone-32.png', width: 32 },
      { src: 'img/cone/cone-64.png', width: 64 },
      { src: 'img/cone/cone-128.png', width: 128 },
      { src: 'img/cone/cone-256.png', width: 256 },
      { src: 'img/cone/cone-320.png', width: 320 },
      { src: 'img/cone/cone-480.png', width: 480 },
      { src: 'img/cone/cone.png', width: 580 },
    ],
    'img/8-big.png': [
      { src: 'img/8-32.png', width: 32 },
      { src: 'img/8-40.png', width: 40 },
      { src: 'img/8-big.png', width: 256 },
    ],
    'img/table/table.png': [
      { src: 'img/table/table-64.png', width: 64 },
      { src: 'img/table/table-128.png', width: 128 },
      { src: 'img/table/table-256.png', width: 256 },
    ],
    'img/tree/tree.png': [
      { src: 'img/tree/tree-64.png', width: 64 },
      { src: 'img/tree/tree-128.png', width: 128 },
      { src: 'img/tree/tree-256.png', width: 256 },
    ],
    'img/enrolment/enrolment.png': [
      { src: 'img/enrolment/enrolment-24.png', width: 24 },
      { src: 'img/enrolment/enrolment-32.png', width: 32 },
      { src: 'img/enrolment/enrolment-48.png', width: 48 },
      { src: 'img/enrolment/enrolment-64.png', width: 64 },
      { src: 'img/enrolment/enrolment-128.png', width: 128 },
      { src: 'img/enrolment/enrolment.png', width: 200 },
    ],
    'img/balls-42.avif': [
      { src: 'img/balls-42.avif', width: 168 },
      { src: 'img/balls-84.avif', width: 336 },
    ],
    'img/cues/tip-32.png': [
      { src: 'img/cues/tip-32.png', width: 32 },
      { src: 'img/cues/tip-64.png', width: 64 },
      { src: 'img/cues/tip-128.png', width: 128 },
    ],
    'img/cues/tip-64.png': [
      { src: 'img/cues/tip-64.png', width: 64 },
      { src: 'img/cues/tip-128.png', width: 128 },
    ],
  },
};
